module.exports = __webpack_public_path__ + "img/26A0.982a2cc4.svg";